export const RESET_PRODUCT_FILTER_ISFETCHING =
  'RESET_PRODUCT_FILTER_ISFETCHING';
export const PRODUCT_FILTER_REQUESTING = 'PRODUCT_FILTER_REQUESTING';

export const LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST =
  'LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST';
export const LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS =
  'LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS';
export const LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST =
  'LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST';
export const LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS =
  'LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS';

export const LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST =
  'LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST';
export const LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS =
  'LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS';
export const LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST =
  'LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST';
export const LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS =
  'LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS';
export const LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST =
  'LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST';
export const LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS =
  'LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS';

export const LIST_PRODUCT_FILTER_VENDORS_REQUEST =
  'LIST_PRODUCT_FILTER_VENDORS_REQUEST';
export const LIST_PRODUCT_FILTER_VENDORS_SUCCESS =
  'LIST_PRODUCT_FILTER_VENDORS_SUCCESS';
